import { select, take } from 'redux-saga/effects';
import firestoreRedux from '@dreamworld/firestore-redux';
import * as aiTeamMemberSelectors from '../ai-team-member/selectors.js';

const isQueryOpen = (query) => query.status === 'LIVE' || query.status === 'PENDING';

/** `feature.isAvailable` reads `false` until the app's feature config query has answered. */
const isFeatureConfigLoaded = (state) => {
  const queries = firestoreRedux.selectors.queriesByRequester(state, 'app-data');
  return queries.length > 0 && !queries.some((query) => query.status === 'PENDING');
};

/**
 * Subscribes a board's AI Team Member collections (sub-collections, read as a collection group by `boardId`) under the
 * board page's or view's requester, once the feature config has loaded and only when it is available for the board's
 * account. Never throws and never rejects: a missing index or rule must not stop the board or view from loading.
 * @param {String[]} collections e.g. `['ai-agent-card-statuses']`.
 * @param {Function} accountIdOfBoard `(state) => accountId`; the board's account may load after the board page starts.
 */
export function* queryBoardCollections({ boardId, requesterId, collections, accountIdOfBoard }) {
  try {
    let state = yield select();
    while (!isFeatureConfigLoaded(state) || !accountIdOfBoard(state)) {
      yield take([firestoreRedux.actions.QUERY_SNAPSHOT, firestoreRedux.actions.QUERY_FAILED]);
      state = yield select();
      if (!firestoreRedux.selectors.queriesByRequester(state, requesterId).some(isQueryOpen)) {
        return;
      }
    }
    if (!aiTeamMemberSelectors.isAvailable(state, accountIdOfBoard(state))) {
      return;
    }
    collections.forEach((collection) => {
      const query = firestoreRedux.query(collection, { id: `${collection}-${boardId}`, where: [['boardId', '==', boardId]], requesterId });
      query.result.catch((error) => console.warn(`AI Team Member: ${collection} query failed for ${boardId}`, error));
    });
  } catch (error) {
    console.warn('AI Team Member: board collections not loaded', { boardId, error });
  }
}
